import React from 'react';
import { Plus, X } from 'lucide-react';

/*
 * Editor fuer eine Liste von Datumsbereichen ({ from, until }).
 * Spiegelt das "+ Datum hinzufuegen" / "Loeschen"-Muster der Einzeltermine
 * (single_event) wider und wird fuer regular_hours, recurring_event und
 * freely_accessible verwendet, um z.B. Schulferien abzubilden.
 *
 * labelFrom/labelUntil sind die Basis-Beschriftungen ohne "(optional)".
 * Ob ein Feld optional ist, ergibt sich pro Zeile aus der Verkettungsregel:
 * - "ab" ist Pflicht ab dem 2. Zeitraum sowie im 1. Zeitraum, wenn
 *   firstFromRequired gesetzt ist (mehrwoechige Wiederholungen).
 * - "bis" ist Pflicht in allen Zeitraeumen ausser dem letzten.
 */
const DateRangeListEditor = ({
  ranges,
  onChange,
  labelFrom = 'Gültig ab',
  labelUntil = 'Gültig bis',
  fromRequired = false,
}) => {
  // Always show at least one (empty) row so the user can start entering data.
  const list = ranges && ranges.length > 0 ? ranges : [{ from: '', until: '' }];

  const renderLabel = (base, required) => (
    <>
      {base}
      {required ? <span className="text-red-500"> *</span> : ' (optional)'}
    </>
  );

  const handleAdd = () => {
    onChange([...list, { from: '', until: '' }]);
  };

  const handleRemove = (index) => {
    if (list.length > 1) {
      onChange(list.filter((_, i) => i !== index));
    } else {
      onChange([{ from: '', until: '' }]);
    }
  };

  const handleChange = (index, field, value) => {
    onChange(list.map((r, i) => (i === index ? { ...r, [field]: value } : r)));
  };

  return (
    <div className="space-y-4">
      {list.map((range, index) => (
        <div key={index} className="single-event-date-group">
          <div className="single-event-date-header">
            <label className="block text-sm font-medium mb-2">
              {list.length > 1 ? `Zeitraum ${index + 1}` : 'Zeitraum'}
            </label>
            <div className="single-event-date-actions">
              {index === list.length - 1 && (
                <button
                  type="button"
                  onClick={handleAdd}
                  className="icon-btn icon-btn-add"
                  title="Weiteren Zeitraum hinzufügen"
                >
                  <Plus size={18} />
                </button>
              )}
              {list.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemove(index)}
                  className="icon-btn icon-btn-remove"
                  title="Zeitraum entfernen"
                >
                  <X size={18} />
                </button>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">
                {renderLabel(labelFrom, index > 0 || fromRequired)}
              </label>
              <input
                type="date"
                value={range.from || ''}
                onChange={(e) => handleChange(index, 'from', e.target.value)}
                className="input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">
                {renderLabel(labelUntil, index < list.length - 1)}
              </label>
              <input
                type="date"
                value={range.until || ''}
                onChange={(e) => handleChange(index, 'until', e.target.value)}
                className="input"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DateRangeListEditor;
